import { render, staticRenderFns } from "./CustomerInfo.htm?vue&type=template&id=1a330688&scoped=true&"
import script from "./CustomerInfo.ts?vue&type=script&lang=js&"
export * from "./CustomerInfo.ts?vue&type=script&lang=js&"
import style0 from "./CustomerInfo.scss?vue&type=style&index=0&id=1a330688&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a330688",
  null
  
)

export default component.exports